module.exports = __webpack_public_path__ + "files/78a158ecab1524a68a0d51f3fcc38add.png";